import Controller from "@sabyr-dev/mist_core/controller";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { InitializeEvent } from "@sabyr-dev/mist_core/events";
import { AcademyApp } from "../app";

export class TestInitController extends Controller<Product, Attempt, Quiz, Question> {
	bind(target: EventTarget, app: AcademyApp): void {
		target.addEventListener(InitializeEvent.type, () => this.initialize(app));
	}

	async initialize(app: AcademyApp): Promise<void> {
		app.model.list.getItemList().then(list => {
			for (const item of list) {
				if (item.answer) {
					app.view.list.displaySelectedAnswer(item.id, item.answer, undefined);
				}
			}
		});
	}
}
